import React from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Date from '../../../../Core/Fields/Floating/Date';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import NewMultiFileInput from '../../../../Core/Fields/Floating/NewMultiFileInput';

const GeneralDetailsTab1 = ({ formData, onFieldChange, extraData }) => {
  return (
    <div className="px-4 py-4" style={{ background: 'white' }}>
      <div style={{ display: 'flex', gap: '20px' }}>

        {/* Left Column */}
        <div style={{ width: '50%' }}>
          <div style={{ backgroundColor: '#EBE6FA', height: '100%', borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
            
            {/* Row 1 */}
            <div style={{ display: 'flex', gap: '15px' }}>
              <div style={{ flex: 1 }}>
                <Date
                  label="Posting Date"
                  style={{ height: '30px' }}
                  value={formData.posting_date}
                  onChange={(e) => onFieldChange('posting_date', e.target.value)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <SelectSearch
                  label="Status"
                  list={extraData.status_list}
                  style={{ height: '30px' }}
                  getOptionLabel={(item) => item.name}
                  getOptionValue={(item) => item.name}
                  value={formData.status}
                  onChange={(val) => onFieldChange('status', val)}
                />
              </div>
              <div style={{ flex: 1.5 }}>
                <SelectSearch
                  label="Company"
                  list={extraData.company_list}
                  style={{ height: '30px' }}
                  getOptionLabel={(item) => item.name}
                  getOptionValue={(item) => item.name}
                  value={formData.company}
                  onChange={(val) => onFieldChange('company', val)}
                />
              </div>
            </div>

            {/* Row 2 */}
            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
              <div style={{ flex: 1 }}>
                <Input
                  label="Sales Person"
                  style={{ height: '30px' }}
                  value={formData.sales_person}
                  onChange={(e) => onFieldChange('sales_person', e.target.value)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Input
                  label="Customer"
                  style={{ height: '30px' }}
                  value={formData.customer}
                  onChange={(e) => onFieldChange('customer', e.target.value)}
                />
              </div>
              <div style={{ flex: 1.5 }}>
                <Textarea
                  label="Remarks"
                  style={{ height: '30px' }}
                  value={formData.remarks}
                  onChange={(e) => onFieldChange('remarks', e.target.value)}
                />
              </div>
            </div>

          </div>
        </div>

        {/* Right Column */}
        <div style={{ width: '50%' }}>
          <div style={{ backgroundColor: '#E3F5DF', height: '100%', borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
            
            {/* Row 1 */}
            <div style={{ display: 'flex', gap: '15px' }}>
              <div style={{ flex: 1 }}>
                <SelectSearch
                  label="Mode of Payment"
                  list={extraData.payment_modes}
                  style={{ height: '30px' }}
                  getOptionLabel={(item) => item.name}
                  getOptionValue={(item) => item.name}
                  value={formData.mode_of_payment}
                  onChange={(val) => onFieldChange('mode_of_payment', val)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Input
                  label="Paid Amount"
                  style={{ height: '30px' }}
                  value={formData.paid_amount}
                  onChange={(e) => onFieldChange('paid_amount', e.target.value)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Input
                  label="Account Paid To"
                  style={{ height: '30px' }}
                  value={formData.account_paid_to}
                  onChange={(e) => onFieldChange('account_paid_to', e.target.value)}
                />
              </div>
                    <div style={{ flex: 1 }}>
                <Input
                  label="Gross Weight"
                  style={{ height: '30px' }}
                  value={formData.gross_weigh}
                  onChange={(e) => onFieldChange('gross_weigh', e.target.value)}
                />
              </div>
            </div>

            {/* Row 2 */}
            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
        
              <div style={{ flex: 2 }}>
                <NewMultiFileInput
                  name="Image"
                  setFile={(files) => onFieldChange('image', files)}
                  style={{ width: '200px' }}
                  error={false}
                />
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default GeneralDetailsTab1;
